import { lazyWithRetry } from "@simplicity/ui";
import { Suspense } from "react";

const SqlEditor = lazyWithRetry(() => import("./SqlEditor"));

interface SqlTextareaProps {
  value: string;
  onChange: (value: string) => void;
  id?: string;
  /** SIM-1689: forwarded to SqlEditor. Smaller in side-by-side layouts. */
  bottomReservePx?: number;
}

function SqlTextareaFallback() {
  return (
    <div
      className="flex items-center justify-center rounded border border-border bg-muted/30 font-mono text-sm text-muted-foreground"
      style={{ minHeight: "200px" }}
    >
      Loading editor...
    </div>
  );
}

export function SqlTextarea({ value, onChange, id, bottomReservePx }: SqlTextareaProps) {
  return (
    <Suspense fallback={<SqlTextareaFallback />}>
      <SqlEditor value={value} onChange={onChange} id={id} bottomReservePx={bottomReservePx} />
    </Suspense>
  );
}
